import React, { useState, useEffect } from "react";
import { Grid, Button, Box, Typography, TextField, FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@material-ui/core";
import AddDataForm from "./AddDataForm.js";
import TableComponent from "../dashboard/components/Table/Table.js";
import axios from "axios";
// import * as XLSX from "xlsx";
import { BACKEND_BASE_URL } from "../../config.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "@mui/material";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function Tables() {
  const [data, setData] = useState([]); // Initialize empty data array
  const [filteredData, setFilteredData] = useState([]); // State for filtered data
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const [sortKey, setSortKey] = useState(""); // Default sorting by date (recent first)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;
  const [urlLoading, setUrlLoading] = useState(false)
  const [liveCitiesCount, setLiveCitiesCount] = useState(0);
  const [apiKeys, setApiKeys] = useState([]);
  const [selectedApiKey, setSelectedApiKey] = useState('');


  useEffect(() => {
    axios
      .get(`${BACKEND_BASE_URL}/api/municipalities/unique_municipalities/`)
      .then((res) => {
        setLiveCitiesCount(res?.data.total_unique_count);

      })
      .catch((err) => {
        console.error("Error fetching live cities count:", err);
      });
  }, []);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("search");
    const channelUrls = JSON.parse(sessionStorage.getItem('channel_urls') || '[]');
    const state = sessionStorage.getItem('state')
    const county = sessionStorage.getItem('county')
    if (query) {
      // setSearchQuery(query);
      handleSearchWithQuery(query, channelUrls, state, county); // separate function that searches by query
    }
  }, [location.search]);

  const fetchAPIKeys = async () => {
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/youtube-api-keys/`);
      const keys = response?.data;
      setApiKeys(keys);

      // Set default to first key if available
      if (keys.length > 0) {
        setSelectedApiKey(keys[0].api_key);
      }
    } catch (error) {
      toast.error('Failed to fetch API keys.', 'error');
    }
  };


  useEffect(() => {
    fetchAPIKeys();
  }, []);




  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("search");

    // Skip default fetch if a search query is present
    if (query) return;

    setUrlLoading(true);
    axios
      .get(`${BACKEND_BASE_URL}/api/urls/?page=${currentPage}&page_size=${itemsPerPage}`)
      .then((response) => {
        const fetchedData = response.data.results;
        setTotalCount(response.data.count);

        setData(fetchedData);
        setFilteredData(fetchedData);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setUrlLoading(false);
      });
  }, [currentPage, location.search]);


  const handleSearchChange = (event) => {
    const query = event.target.value.toLowerCase(); // Normalize query

    setSearchQuery(query);
  };

  const handleSearchWithQuery = async (query, channelUrls, state, county) => {
    setUrlLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("search", query);
      params.append("page", "1");
      params.append("page_size", itemsPerPage.toString());
      params.append("state", state);
      params.append("county", county);

      // Append each channel URL without []
      channelUrls.forEach((url) => {
        params.append("channel_urls", url);
      });

      const response = await axios.get(`${BACKEND_BASE_URL}/api/urls/?${params.toString()}`);

      setData(response.data.results);
      setFilteredData(response.data.results);
      setTotalCount(response.data.count);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error searching:", error);
    } finally {
      setUrlLoading(false);
    }
  };


  const handleSortChange = (event) => {
    const key = event.target.value;
    setSortKey(key);

    const sortedData = [...filteredData].sort((a, b) => {
      if (key === "entry_date_desc") {
        // Sort by date (recent first)
        return b.id - a.id;
      } else if (key === "entry_date_asc") {
        // Sort by ID (oldest first)
        return a.id - b.id;

      } else if (key === "alphabetical_asc") {
        // Sort alphabetically A-Z
        const aValue = `${a.state || ""} ${a.county || ""} ${a.municipality_name || ""}`.toLowerCase();
        const bValue = `${b.state || ""} ${b.county || ""} ${b.municipality_name || ""}`.toLowerCase();
        return aValue.localeCompare(bValue);
      } else if (key === "alphabetical_desc") {
        // Sort alphabetically Z-A
        const aValue = `${a.state || ""} ${a.county || ""} ${a.municipality_name || ""}`.toLowerCase();
        const bValue = `${b.state || ""} ${b.county || ""} ${b.municipality_name || ""}`.toLowerCase();
        return bValue.localeCompare(aValue);
      }
      return 0; // Default
    });

    setFilteredData(sortedData);
  };



  const handleAddClick = () => {
    setOpen(true); // Open the form dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the form dialog
  };

  const handleAddData = (newData) => {
    // Update the state with the new data

    setData((prevData) => [...prevData, ...newData]);  // Spread the newData array to add both items
    setFilteredData((prevData) => [...prevData, ...newData]); // Also update filtered data
  };

  const handleDelete = async (id) => {
    try {
      // Make DELETE request to backend
      await axios.delete(`${BACKEND_BASE_URL}/api/delete-url/${id}/`);
      // Filter out the item with the given id and update the data state
      setData((prevData) => prevData.filter((item) => item.id !== id));
      setFilteredData((prevData) => prevData.filter((item) => item.id !== id)); // Also update filtered data
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const handleDeleteAll = async (data) => {
    try {
      // Prepare the data in the format expected by the backend
      const dataToDelete = [{ id: data.id, state: data.state, county: data.county, municipality_name: data.municipality_name }];



      // Sending the data in the request body as JSON
      await axios.delete(`${BACKEND_BASE_URL}/api/delete-all-data/`, {
        data: dataToDelete, // The backend expects an array of objects with these properties
      });

      // Update the state to remove the deleted item(s)
      setData((prevData) => prevData.filter((item) => !dataToDelete.some(delItem => delItem.id === item.id)));
      setFilteredData((prevData) => prevData.filter((item) => !dataToDelete.some(delItem => delItem.id === item.id))); // Also update filtered data
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };
  const handleEdit = (updatedData) => {
    // Update the state with the new data
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    );

    setFilteredData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    ); // Also update filtered data
  };

  const handleScrapeClick = async () => {
    setLoading(true);
    try {
      await axios.post(`${BACKEND_BASE_URL}/api/scrape-all/`);
    } catch (error) {
      console.error("Error during scraping:", error);

      let errorMessage =
        error|| "Error during scraping";
      // Custom message for YouTube quota exceeded
      if (error.response?.status === 400) {
        errorMessage = error.response?.data?.error;
      }

      toast.error(`${errorMessage}`);
    }
    setLoading(false);
  };

  const handleSearch = async () => {
    setUrlLoading(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/urls/`, {
        params: {
          page: 1,
          page_size: itemsPerPage,
          search: searchQuery,  // Use the state here
        },
      });

      setData(response.data.results);
      setFilteredData(response.data.results);
      setTotalCount(response.data.count);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error searching:", error);
    } finally {
      setUrlLoading(false);
    }
  };



  if (urlLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems={"center"} margin={"auto"}>
        <CircularProgress>
        </CircularProgress>
      </Box>
    )
  }


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" flexDirection="column" >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography style={{ fontWeight: "bold" }} variant="h4">
                Manage Youtube Channel
              </Typography>
              <Box display="flex" alignItems="center">
                <FormControl variant="outlined" size="small" style={{ marginRight: "10px", minWidth: "150px" }}>
                  <InputLabel>Sort By</InputLabel>
                  <Select value={sortKey} onChange={handleSortChange} label="Sort By">
                    <MenuItem value="entry_date_desc">Latest Entry</MenuItem>
                    <MenuItem value="entry_date_asc">Oldest Entry</MenuItem>
                    <MenuItem value="alphabetical_asc">A-Z (State, County, Town)</MenuItem>
                    <MenuItem value="alphabetical_desc">Z-A (State, County, Town)</MenuItem>
                  </Select>
                </FormControl>
                {/* Search Input */}
                <TextField
                  placeholder="Search..."
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  InputProps={{
                    startAdornment: (
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        style={{ marginRight: "8px", color: "#555" }}
                      />
                    ),
                  }}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  style={{ marginRight: "10px" }}
                />
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#0B194A",
                    color: "white",
                  }}
                  disabled={urlLoading}
                >
                  {urlLoading ? <CircularProgress size={20} style={{ color: "white" }} /> : "Search"}
                </Button>

                <Button
                  // color="primary"
                  variant="contained"
                  style={{
                    marginRight: "10px", backgroundColor: "#0B194A",
                    color: "white",
                  }}
                  onClick={handleScrapeClick}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Scrape ALL"}
                </Button>

                <Button
                  variant="contained"
                  onClick={handleAddClick}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#0B194A",
                    color: "white",
                  }}
                >
                  Add
                </Button>


              </Box>
            </Box>
            {/* New live cities count here */}
            <Typography variant="subtitle1" style={{ color: "black", marginTop: "5px", fontWeight: "bold" }}>
              Total Live Cities: {liveCitiesCount?.toLocaleString()}
            </Typography>

            <Box display="flex" justifyContent="flex-end" marginTop="20px">
              <FormControl
                variant="outlined"
                size="small"
                style={{ minWidth: "220px" }}
              >
                <InputLabel id="api-key-label">Select API Key</InputLabel>
                <Select
                  labelId="api-key-label"
                  value={selectedApiKey}
                  onChange={(e) => setSelectedApiKey(e?.target?.value)}
                  label="Select API Key"
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null, // prevents the default anchoring behavior
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        marginTop: 8,
                      },
                    },
                  }}
                >
                  {apiKeys.length > 0 ? (
                    apiKeys.map((keyObj, index) => (
                      <MenuItem key={index} value={keyObj?.api_key}>
                        {keyObj?.name || keyObj?.api_key}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No API keys available</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>


          </Box>
          <AddDataForm open={open} onClose={handleClose} onSubmit={handleAddData} api={selectedApiKey} />
        </Grid>

        

        <Grid item xs={12}>

          {/* Pass filteredData to TableComponent */}
          <TableComponent
            data={filteredData}
            handleDelete={handleDelete}
            handleDeleteAll={handleDeleteAll}
            handleEdit={handleEdit}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            api={selectedApiKey}
           
          />
        </Grid>

        <Box display="flex" justifyContent="center" alignItems={"center"} margin={"auto"} mb={2}>
          <Pagination
            count={Math.ceil(totalCount / itemsPerPage)}
            page={currentPage}
            onChange={(e, value) => setCurrentPage(value)}
            color="primary"
          />
        </Box>
      </Grid>
    </>
  );
}

